import { CatalogoService } from './services/catalogo.service';
import { ImageService } from './services/image.service';
import { OauthService } from './services/oauth.service';
import { UserService } from './services/user.service';
import { ShareModule } from './modules/share/share.module';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SyncService } from './services/sync.service';
import { MenuDirective } from './directives/menu.directive';
import { IonicStorageModule } from '@ionic/storage-angular';
import { CartService } from './services/cart.service';
import { registerLocaleData } from '@angular/common';
import it from '@angular/common/locales/it';
import { BarcodeComponent } from './components/sections/barcode/barcode.component';
import { UserState } from './states/UserState';
import { NgxsModule } from '@ngxs/store';
import { CatalogoState } from './states/CatalogoState';

registerLocaleData(it);

@NgModule({
  declarations: [AppComponent, MenuDirective, BarcodeComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ShareModule,
    IonicStorageModule.forRoot(),
    NgxsModule.forRoot([UserState, CatalogoState], {
      developmentMode: false
    })
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'it-IT'},    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    SyncService,
    UserService,
    OauthService,
    ImageService,
    CartService,
    CatalogoService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
